import { z } from "zod/v4-mini";

import { cz } from "@/utils/zodUtils";

import { TandemEventDefinition } from "../TandemTypes";

export type ReminderTimeParamsChangePayload = {
  modification?: number;
  reminder_id?: number;
  status?: number;
  enable?: number;
  frequency_minutes?: number;
  start_time?: number;
  end_time?: number;
  active_days?: number;
};

export type ReminderTimeParamsChangeEvent = {
  modification?: number;
  reminderId?: number;
  status?: number;
  enable?: number;
  frequencyMinutes?: number;
  startTime?: number;
  endTime?: number;
  activeDays?: number;
};

const reminderTimeParamsChangeSchema = z.object({
  modification: cz.permissive(z.number()),
  reminder_id: cz.permissive(z.number()),
  status: cz.permissive(z.number()),
  enable: cz.permissive(z.number()),
  frequency_minutes: cz.permissive(z.number()),
  start_time: cz.permissive(z.number()),
  end_time: cz.permissive(z.number()),
  active_days: cz.permissive(z.number()),
});

export const LID_PARAM_REMINDER = {
  value: 0x60,
  name: "Reminder Time Based Parameter Change Event",
  format: "bbbbihhb...",
  fields: [
    "modification",
    "reminder_id",
    "status",
    "enable",
    "frequency_minutes",
    "start_time",
    "end_time",
    "active_days",
  ],
  postprocess: rec => ({
    modification: rec.modification,
    reminderId: rec.reminder_id,
    status: rec.status,
    enable: rec.enable,
    frequencyMinutes: rec.frequency_minutes,
    startTime: rec.start_time,
    endTime: rec.end_time,
    activeDays: rec.active_days,
  }),
  schema: reminderTimeParamsChangeSchema,
} as const satisfies TandemEventDefinition<ReminderTimeParamsChangePayload, ReminderTimeParamsChangeEvent>;
